import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PublicLayout, PageContainer, PageHeader } from "@/components/PublicLayout";
import { useSeo } from "@/lib/useSeo";
import { LoadingState, ErrorState } from "@/components/States";
import { ArrowRight } from "@phosphor-icons/react";

export default function PredictTarget() {
  useSeo({ title: "Guwahati Morning Teer Predict Target | Direct House Ending Today", description: "Guwahati Morning Teer daily target - Direct Number, House and Ending reference that updates every day. Informational and entertainment only.", path: "/predict-target" });
  const q = useQuery({ queryKey: ["daily-guti"], queryFn: async () => (await api.get("/daily/guti")).data });

  const rows = q.data
    ? [
        { label: "Direct Number", value: q.data.direct.join(", "), tone: "from-amber-400 to-orange-500" },
        { label: "House", value: q.data.house, tone: "from-teal-400 to-cyan-600" },
        { label: "Ending", value: q.data.ending, tone: "from-brand to-brand-hover" },
      ]
    : [];

  return (
    <PublicLayout>
      <PageContainer className="py-10">
        <PageHeader
          eyebrow="Daily Target"
          title="Predict Target"
          subtitle="Auto-updating Direct Number, House and Ending reference for today. These change automatically every day."
        />

        {q.isLoading ? (
          <LoadingState />
        ) : q.isError ? (
          <ErrorState onRetry={q.refetch} />
        ) : (
          <>
            <p className="text-sm font-semibold text-slate-500 mb-4" data-testid="predict-date">Date: {q.data.date}</p>
            <div className="space-y-4" data-testid="predict-target">
              {rows.map((r) => (
                <div
                  key={r.label}
                  data-testid={`predict-row-${r.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`flex items-center gap-4 rounded-2xl bg-gradient-to-r ${r.tone} text-white p-5 shadow-[0_8px_28px_-8px_rgba(0,0,0,0.3)]`}
                >
                  <ArrowRight className="w-7 h-7 flex-shrink-0" weight="bold" />
                  <div className="flex-1 flex items-center justify-between">
                    <span className="font-heading font-bold text-base sm:text-lg">{r.label}</span>
                    <span className="font-heading font-black text-2xl sm:text-3xl tabular-nums">{r.value}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="mt-8 rounded-2xl bg-slate-50 border border-slate-100 p-5">
          <p className="text-sm text-slate-500 leading-relaxed">
            <strong className="text-slate-700">Disclaimer:</strong> Predict Target numbers are generated
            automatically for informational and entertainment purposes only. They are not a guaranteed
            prediction, forecast, or recommendation of any Teer result.
          </p>
        </div>
      </PageContainer>
    </PublicLayout>
  );
}
